import { faker } from '@faker-js/faker'
import { build, perBuild, sequence } from '@jackfranklin/test-data-bot'

import { MarketCountryCode } from '../../api-models/MarketCountryCode'
import type { CategoryLeafLight } from '../../api-specs-catalog/catalog-access'

import type { PricingRule } from './pricing-rules.types'

export const categoryBuilder = build<CategoryLeafLight>('Category', {
  fields: {
    categoryId: sequence((id) => id),
    categoryName: perBuild(() => faker.string.alphanumeric(10)),
    marketplaceCategoryId: perBuild(() => faker.string.numeric(4)),
  },
})

const categories: CategoryLeafLight[] = Array.from(
  { length: 3 },
  categoryBuilder,
)

export const ruleBuilder = (targetMarket: MarketCountryCode) =>
  build<PricingRule>({
    fields: {
      id: perBuild(() => faker.string.uuid()),
      lastTaskCreationDate: perBuild(() => faker.string.numeric(5)),
      category: perBuild(() => {
        const categoryIndex = Math.floor(
          Math.random() * (categories.length - 1 - 0 + 1) + 0,
        )

        return {
          id: Number(categories[categoryIndex].marketplaceCategoryId),
          name: categories[categoryIndex].categoryName,
        }
      }),
      multiplier: perBuild(() => faker.number.int({ min: 1, max: 5 })),
      offset: perBuild(() => ({
        amount: faker.number.int({ min: 1, max: 100 }).toString(),
        currency: 'EUR',
      })),
      sourceMarket: MarketCountryCode.FR,
      targetMarket,
    },
  })()
